// extracted by mini-css-extract-plugin
export default {"move-in-right":"_1CAWm","moveInRight":"_1CAWm","move-in-left":"_3833r","moveInLeft":"_3833r"};